import React from 'react';
import {QRCode} from "antd";
import logo from "../../../images/logo2.svg";

const PrintPage = ({data, numberPerPallet}) => {
    return (<div className='p-1 text-black text-sm'>


            <div className='border  ' dir='rtl'>
                <div className="grid text-center text-sm font-bold grid-cols-2">
                    <div className=" border p-2   ">
                        <h1>هتل اسکان الوند</h1>

                    </div>

                    <div className="border p-2   ">
                        <h1>{data?.productLine}</h1>

                    </div>


                </div>
                <div className="border p-1 py-2">
                    <h2 className='text-center text-lg font-bold'>{data?.product}</h2>
                </div>
 
       

                <div className="border p-1">
                    <div className="flex items-center justify-between">
                        <div><QRCode value={`${data?.palletId}`} type='svg' color='black'/></div>
                        <div className='flex justify-between h-full flex-col flex-1'>
                            <h2 className='text-center text-xl font-bold'>{data?.palletId}</h2>
                            <div className='flex flex-col gap-1 items-center justify-center  mt-6'>

                                <img className='w-24' src={logo} alt=""/>
                                <span className='text-lg '>iotfig.com</span>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintPage;